<template>
  <div class="accordion">
    <div class="header" @click="toggleOpenState">
      <slot name="header" />
      <div class="additionals">
        <FaIcon
          icon="angle-down"
          class="header-icon"
          :class="{ rotate: openInternal }"
        />
        <slot name="icon" />
      </div>
    </div>
    <transition
      name="accordion"
      @after-enter="unsetBodyHeight"
      @enter="setBodyHeight"
      @before-leave="setBodyHeight"
      @leave="resetBodyHeight"
    >
      <div class="body" v-show="openInternal">
        <div class="body-inner">
          <slot />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/**
 * Accordion component
 * @displayName Accordion
 *
 * @example <Accordion><div slot="header">Header</div>Content</Accordion>
 *
 * @author Mikkel.lindblom@edulab.dk <mikkel.lindblom@edulab.dk>
 */
import FaIcon from './FaIcon'

export default {
  components: { FaIcon },
  props: {
    open: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      openInternal: this.open,
    }
  },
  methods: {
    toggleOpenState() {
      this.openInternal = !this.openInternal
    },
    setBodyHeight(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    resetBodyHeight(el) {
      setTimeout(() => {
        el.style.height = '0'
      })
    },
    unsetBodyHeight(el) {
      el.style.height = 'auto'
    },
  },
  watch: {
    open(open) {
      this.openInternal = open
    },
  },
}
</script>

<style lang="scss" scoped>
.accordion {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 1em;

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 1em;
    cursor: pointer;
    color: $gray;
    font-size: 1.25em;

    > h2,
    > h3 {
      margin: 0;
    }

    .header-icon {
      font-size: 1.5em;
      transform: rotate(0deg);
      transition-duration: $transitionMedium;
    }

    .header-icon.rotate {
      transform: rotate(180deg);
    }

    .additionals {
      display: flex;
      align-items: center;

      > * {
        margin-left: 1.5em;
      }
    }
  }

  .body {
    overflow: hidden;
    background-color: $white;
    border-top: 1px solid $grayLighter;
    border-radius: 0 0 1em 1em;
    transition: height $transitionMedium ease-out;
  }

  .body-inner {
    padding: 1em;
    overflow-wrap: break-word;
  }
}
</style>
